import React from 'react';

function StatCard({ title, value, change, unit }) {
  const isPositive = change > 0;
  const changeColor = isPositive ? '#ff6b6b' : '#7CC644';

  const formatValue = (val) => {
    if (val === null || val === undefined) return '—';
    if (typeof val === 'number') {
      if (Math.abs(val) >= 1000000) return (val / 1000000).toFixed(2) + 'M';
      if (Math.abs(val) >= 1000) return (val / 1000).toFixed(1) + 'K';
      if (Number.isInteger(val)) return val.toLocaleString();
      return val.toFixed(3);
    }
    return val;
  };

  return (
    <div className="case-study-stat-card">
      <div className="stat-title">{title}</div>
      <div className="stat-value">
        {formatValue(value)}
        {unit && <span className="stat-unit"> {unit}</span>}
      </div>
      {change !== null && change !== undefined && (
        <div className="stat-change" style={{ color: changeColor }}>
          {isPositive ? '+' : ''}{change.toFixed(1)}%
        </div>
      )}
    </div>
  );
}

export default StatCard;
